import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import React from "react";
import { Footer } from "./modules/Footer/Footer";
import { CustomSenderSection } from "./modules/CustomSenderSection/CustomSenderSection";
import { FeaturesSection } from "./modules/FeaturesSection/FeaturesSection";
import { useESUnlockModalStore } from "./store/useESUnlockModalStore";

export const EmailSenderUnlockModal = () => {
  const modalOpen = useESUnlockModalStore((store) => store.modalOpen);
  const setModalOpen = useESUnlockModalStore((store) => store.setModalOpen);

  const handleModalClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setModalOpen(false);
  };

  return (
    <ExlyModal
      open={modalOpen}
      onClose={handleModalClose}
      onClickCross={handleModalClose}
      title={
        <div className="tw-text-[#2c207e] tw-text-[18px] tw-font-bold tw-leading-normal">
          Pay & Unlock: Custom Email Sender IDs
        </div>
      }
      customFooter={<></>}
      className="!tw-p-[24px] !tw-bg-[#eae7fa] tw-flex tw-flex-col tw-gap-[24px] max-md:tw-p-[16px]"
      modal_props={{ modalPaperClassName: "tw-min-w-[604px]" }}
    >
      <CustomSenderSection />

      <FeaturesSection />

      <Footer onClose={handleModalClose} />
    </ExlyModal>
  );
};
